<template>
  <div>
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :count="count"
      :current="page">
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem" v-if="roleType!==2">
          <label>门店名称:</label>
          <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
        </div>
        <div class="queryItem">
          <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
        </div>
        <div class="queryItem">
          <label>有效天数小于等于:</label>
          <lk-input-number
            class="item"
            placeholder="请输入"
            clearable
            :min="0"
            :max="999999999"
            :precision="0"
            v-model.trim="query.beforeExpireDays">
          </lk-input-number>
        </div>
        <div class="queryItem storeSelect">
          <label>商品仓库:</label>
          <lk-select class="item" filterable multiple v-model.trim="query.warehouseIds" placeholder="全部">
            <lk-option v-for="item in warehouses" :key="item.id" :value="item.id">
              {{item.warehouseName}}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>商品类型:</label>
          <lk-select class="item" v-model="query.type" clearable>
            <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>

        <div class="queryItem">
          <label>来源:</label>
          <lk-select class="item" v-model="query.purchaseType" clearable>
            <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>批号:</label>
          <lk-input class="item" v-model.trim="query.batchCode" :maxlength="50" clearable placeholder="请输入"></lk-input>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr" @click="handleSearch(false, resetSelectedGoods)">查询</lk-button>
          <lk-button @click="handleReset">重置</lk-button>
        </div>
      </div>
      <div slot="table">
        <lk-button
          class="mr8"
          type="primary"
          icon="md-add"
          @click="addUnqualifiedRecord"
          :disabled="selectedGoodsList.length === 0"
          v-if="handlePermission('expireUnqualifiedAdd')">生成不合格记录
        </lk-button>
        <lk-button
          class="mr8"
          type="primary"
          @click="handlePrint"
          :disabled="selectedGoodsList.length === 0"
          v-if="handlePermission('expireUnqualifiedPrint')">打印所选
        </lk-button>
        <!-- 异步导出Excel Start -->
        <DownloadButton class="mb16" @on-click="download" v-if="handlePermission('expireExcel')"></DownloadButton>
        <!-- 异步导出Excel End -->
        <lk-table
          border
          :columns="columns"
          :data="tableData"
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel"></lk-table>
      </div>
    </QueryFrame>
    <LinkQR017 ref="LinkQR017"/>
    <!-- 商品有效期小于0天的提示 ！！需要产品确认 -->
    <DTPModal
      v-model="showModal"
      :content="showText">
    </DTPModal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import DTPModal from '../../components/DTPModal.vue';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import LinkQR017 from '../../components/print/LinkQR017';
import DownloadButton from '../../components/download/DownloadButton';

export default {
  name: 'expireAlert',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DTPModal,
    LinkQR017,
    DownloadButton,
  },
  data() {
    return {
      showModal: false,
      showText: '',
      warehouses: [],
      query: {
        storeIdList: [],
        nameMix: null,
        beforeExpireDays: null,
        goodsTypeIds: [],
        warehouseIds: [],
        type: null, // 商品类型
        purchaseType: null, // 来源
        batchCode: null, // 批号
      },
      columns: [
        {
          title: '选择',
          type: 'selection',
          width: 60,
        },
        {
          title: '序号',
          type: 'index',
          minWidth: 70,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
          tooltip: true,
        },
        {
          title: '商品编码',
          key: 'inventoryExpireDrugSerialCode',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '商品名称',
          key: 'inventoryExpireGoodsName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '通用名称',
          key: 'inventoryExpireApprovedDrugNames',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '规格',
          key: 'inventoryExpireSpecifications',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '剂型',
          key: 'inventoryExpireDosageForm',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '生产厂家',
          key: 'inventoryExpireManufacturer',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '上市许可持有人',
          minWidth: 120,
          tooltip: true,
          key: 'mah',
        },
        {
          title: '商品类型',
          key: 'inventoryExpireGoodsTypeName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '来源',
          key: 'inventoryExpirePurchaseTypeName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '商品状态',
          key: 'inventoryExpireGoodsStoreStatusStr',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '单位',
          key: 'inventoryExpireDrugMiniPackageUnit',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '商品仓库',
          key: 'inventoryExpireWarehouseName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '货位',
          key: 'inventoryExpireLocationCode',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '数量',
          key: 'inventoryExpireGoodsStockAmount',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '批次',
          key: 'inventoryExpireGoodsBatchSeq',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '批号',
          key: 'inventoryExpireGoodsBatchNumber',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '入库日期',
          key: 'inventoryExpireCreateTime',
          minWidth: 120,
          tooltip: true,
        },
        {
          title: '生产日期',
          key: 'inventoryExpireGoodsProductionDate',
          minWidth: 120,
          tooltip: true,
        },
        {
          title: '有效日期',
          key: 'inventoryExpireGoodsExpiryDate',
          minWidth: 120,
          tooltip: true,
        },
        {
          title: '有效天数',
          key: 'inventoryExpireBeforeExpireDays',
          minWidth: 120,
          tooltip: true,
        },
        {
          title: '预警天数',
          key: 'inventoryExpirePeriodAlertDays',
          minWidth: 120,
          tooltip: true,
        },
      ],
      tableData: [],
      selectedGoodsList: [],
    };
  },
  computed: {
    ...mapGetters([
      'getGoodsOrigin',
      'getNormalGoodsTypes',
    ]),
    selectedTempGoodsIds() { // 临时选中的明细
      const result = [];
      this.selectedGoodsList.forEach((item) => {
        result.push(item.inventoryExpireId);
      });
      return result;
    },
  },
  methods: {
    handlePrint() {
      console.log(this.selectedGoodsList);
      const inventoryIds = [];
      this.selectedGoodsList.forEach((item) => {
        inventoryIds.push(item.inventoryExpireId);
      });
      this.$refs.LinkQR017.handlePrint(inventoryIds);
    },
    getWarehouses() {
      inventory.warehouseList().then((res) => {
        if (res.data.status === 200) {
          this.warehouses = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      inventory.expireCount({}).then((response) => {
        if (response.data.status === 200) {
          this.showModal = false; // true: 待产品确认该需求
          this.showText = `请注意，商品有效期小于0天的商品共有${response.data.data}个！`;
          const params = utils.deepClone(this.query);
          params.page = this.page;
          params.size = this.size;
          inventory.expireList(params).then((res) => {
            if (res.data.status === 200) {
              this.tableData = [];
              const { count, list } = res.data.data;
              list.forEach((item) => {
                const result = {};
                utils.exchangeTable(item, result);
                result.inventoryExpireCreateTime = utils.exchangeTime(result.inventoryExpireCreateTime);
                result.inventoryExpireGoodsProductionDate = utils.exchangeTime(result.inventoryExpireGoodsProductionDate);
                result.inventoryExpireGoodsExpiryDate = utils.exchangeTime(result.inventoryExpireGoodsExpiryDate);

                result._checked = this.selectedTempGoodsIds.includes(result.inventoryExpireId);
                this.tableData.push(result);
              });
              this.count = count;
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        } else {
          this.$Message.error(response.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleTempSelect(selection, row) {
      if (!this.selectedTempGoodsIds.includes(row.inventoryExpireId)) {
        this.selectedGoodsList.push(row);
      }
    },
    handleTempCancel(selection, row) {
      this.selectedGoodsList.forEach((item, index) => {
        if (item.inventoryExpireId === row.inventoryExpireId) {
          this.selectedGoodsList.splice(index, 1);
        }
      });
    },
    handleSelectAll(selection) {
      selection.forEach((item) => {
        if (!this.selectedTempGoodsIds.includes(item.inventoryExpireId)) {
          this.selectedGoodsList.push(item);
        }
      });
    },
    handleSelectAllCancel() {
      this.tableData.forEach((good) => {
        for (let i = 0, len = this.selectedGoodsList.length; i < len; i++) {
          if (this.selectedGoodsList[i].inventoryExpireId === good.inventoryExpireId) {
            this.selectedGoodsList.splice(i, 1);
            break;
          }
        }
      });
    },
    addUnqualifiedRecord() {
      if (this.selectedGoodsList.length === 0) {
        this.$Message.error('请选择记录');
        return;
      }

      // 生成不合格记录
      const ids = [];
      this.selectedGoodsList.forEach((item) => {
        ids.push(item.inventoryExpireId);
      });
      this.$router.push({
        name: 'expireUnqualifiedAdd',
        params: {
          ids: ids.join(','),
        },
      });
    },
    handleReset() {
      this.query = {
        beforeExpireDays: null,
      };
    },
    resetSelectedGoods() {
      this.selectedGoodsList = [];
    },
    download() {
      const params = Object.assign({}, this.params);
      params.page = 0;
      params.size = 0;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      inventory.expireDownload(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getWarehouses();
    this.handleSearch(true, this.resetSelectedGoods);

    if (this.roleType !== 2) {
      this.columns.splice(2, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
  },
};
</script>
<style lang="less" scoped>
</style>
